import styles from "./YandexMap.module.scss";
import { YMaps, Map, Placemark } from "@pbe/react-yandex-maps";
import { useEffect, useRef } from "react";
import customMarker from "../../static/images/marker.svg";

export default function YandexMap({ clickedAddress, addresses }) {
  const map = useRef();
  const placemarkRef = useRef([]);

  useEffect(() => {
    if (clickedAddress.addressIdx !== null) {
      map.current?.panTo(addresses[clickedAddress.addressIdx].coordinates, {
        flying: false,
        safe: true,
        delay: 700,
      });
      setTimeout(() => {
        placemarkRef?.current[clickedAddress.addressIdx].balloon.open();
      }, 701);
    }
  }, [clickedAddress, addresses]);

  return (
    <div className={styles.map}>
      <YMaps>
        <Map
          width={"100%"}
          height={"100%"}
          defaultState={{
            center: [55.865725, 47.468563],
            zoom: 8,
          }}
          instanceRef={map}
        >
          {addresses.map((address, idx) => (
            <Placemark
              geometry={address.coordinates}
              options={{
                //preset: "islands#blueIcon'",
                //balloonOffset: [2, -45],
                balloonPanelMaxMapArea: "0",
                hideIconOnBalloonOpen: false,
                balloonMaxWidth: 300,
                iconLayout: "default#image",
                iconImageHref: `${customMarker}`,
                iconImageSize: [110, 55],
                iconImageOffset: [-64, -34.5],
                balloonOffset: [-4, -30],
              }}
              instanceRef={(el) => (placemarkRef.current[idx] = el)}
              properties={{
                balloonContentHeader: "Адрес:",
                balloonContentBody: address.address,
              }}
              modules={["geoObject.addon.balloon", "geoObject.addon.hint"]}
              key={idx}
            />
          ))}
        </Map>
      </YMaps>
    </div>
  );
}
